import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import UserIcon from '../UserIcon';

function UserBadge({ userFirstName, userLastName, disabled = false }) {
  return (
    <Flex
      alignItems="center"
      flexFlow="row nowrap"
      justifyContent="flex-start"
    >
      <Box mr={2}>
        <UserIcon
          disabled={disabled}
          firstName={userFirstName}
          fontSize="xs"
          iconSize="25px"
          lastName={userLastName}
        />
      </Box>
      <Text textStyle="bodyMd500">{`${userFirstName} ${userLastName}`}</Text>
    </Flex>
  );
}

UserBadge.propTypes = {
  userFirstName: PropTypes.string.isRequired,
  userLastName: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

export default UserBadge;
